/* AUTEUR PDP, the results grid settling.

   Three figures count to their value while five ruled blanks draw themselves,
   on one shared timeline. See auteur-pdp-count.css for why both halves move.

   FOUR THINGS THIS DELIBERATELY DOES NOT DO:

   1. It never overshoots. An instrument that swings past and settles back would
      display, for a few frames, a number larger than the one AUTEUR can
      substantiate. The easing is monotonic on a page whose whole argument is
      that it does not overstate.

   2. It never runs twice. Scrolling back up does not replay it. A measurement
      that re-measures every time you look at it is a slot machine.

   3. It never invents a value. The figure is parsed out of the markup the
      merchant typed and put back verbatim at the end. The animation only ever
      interpolates toward text that was already there, and the final assignment
      is the original string, not a rounded reconstruction of it.

   4. It never leaves a wrong number on screen. The end value is asserted on a
      timer as well as by the animation loop, because requestAnimationFrame is
      suspended in a tab the browser is not painting and a counter stranded
      mid-sweep is worse than no counter. This exact failure already happened
      once on this page, on the engineering hub.

   Content is correct in the markup before this file loads. Everything here is
   additive and is armed by a class only this script adds. */
(function () {
  'use strict';

  var DUR = 1180;      /* the sweep itself */
  var STAGGER = 78;    /* per cell, reading order */

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var grids = document.querySelectorAll('[data-count-grid]');
    for (var i = 0; i < grids.length; i++) init(grids[i]);
  });

  function init(grid) {
    var cells = Array.prototype.slice.call(grid.querySelectorAll('.apdp-cell'));
    if (!cells.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;   /* markup is already the finished state */

    /* Parse first. If a single figure will not parse, arm nothing and leave the
       whole grid as typed rather than animating a partial set. */
    var figures = [];
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      if (cell.classList.contains('is-pending')) { figures.push(null); continue; }
      var node = cell.querySelector('.n');
      if (!node) return;
      var raw = node.textContent.trim();
      var m = raw.match(/^([^0-9-]*)(-?\d+(?:\.\d+)?)(.*)$/);
      if (!m) return;
      figures.push({
        node: node,
        cell: cell,
        raw: raw,
        prefix: m[1],
        target: parseFloat(m[2]),
        decimals: (m[2].split('.')[1] || '').length,
        suffix: m[3]
      });
    }

    grid.classList.add('is-armed');

    /* Hold the widest possible reading so a sweep cannot reflow the grid.
       tabular-nums keeps digit width even; this keeps digit COUNT even. */
    figures.forEach(function (f) {
      if (!f) return;
      f.node.style.minWidth = f.node.getBoundingClientRect().width + 'px';
      f.node.textContent = f.prefix + (0).toFixed(f.decimals) + f.suffix;
    });

    cells.forEach(function (c, i) { c.style.setProperty('--d', (i * STAGGER) + 'ms'); });

    var started = false, io = null, lastCheck = 0;

    function near() {
      var r = grid.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return r.top < vh - 60 && r.bottom > 60;
    }

    function onScroll() {
      var now = +new Date();
      if (now - lastCheck < 120) return;
      lastCheck = now;
      if (near()) run();
    }

    function teardown() {
      if (io) { io.disconnect(); io = null; }
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
    }

    function settle(f) {
      f.node.textContent = f.raw;          /* the merchant's exact string */
      f.cell.classList.add('is-settled');
    }

    function run() {
      if (started) return;
      started = true;
      teardown();
      grid.classList.add('is-run');

      figures.forEach(function (f, i) {
        if (!f) return;
        var delay = i * STAGGER;
        var t0 = null;

        function frame(ts) {
          if (t0 === null) t0 = ts;
          var e = ts - t0 - delay;
          if (e < 0) { requestAnimationFrame(frame); return; }
          var p = e / DUR;
          if (p >= 1) { settle(f); return; }
          /* exponential ease-out, monotonic, no overshoot */
          var eased = 1 - Math.pow(2, -10 * p);
          f.node.textContent = f.prefix + (f.target * eased).toFixed(f.decimals) + f.suffix;
          requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);

        /* The assertion. Fires whether or not rAF ever ran. */
        setTimeout(function () { settle(f); }, delay + DUR + 140);
      });
    }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) run();
      }, { threshold: 0.25 });
      io.observe(grid);
    }
    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onScroll);
    [220, 900, 2000].forEach(function (ms) { setTimeout(onScroll, ms); });
    onScroll();
  }
})();
